import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Divider, styled, Typography } from "@mui/material";
export const TabMessageBox = styled(Box)((param)=>{
    let { theme  } = param;
    return {
        backgroundColor: theme.palette.grey[0],
        borderRadius: "6px",
        padding: theme.spacing(3, 0),
        width: "100%",
        textAlign: "center"
    };
});
export const PurchaseDivider = styled(Divider)((param)=>{
    let { theme  } = param;
    return {
        margin: theme.spacing(0, -2.5),
        borderColor: theme.palette.grey[50]
    };
});
export const TabFormSection = (param)=>{
    let { title , children , ...props } = param;
    return /*#__PURE__*/ _jsxs(Box, {
        ...props,
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: "subtitle2",
                sx: {
                    color: "grey.500",
                    mb: 1
                },
                children: title
            }),
            children
        ]
    });
};
